import { Loader2 } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { useReportQuestionError } from "@/hooks/mutations/use-report-question-error";
import { closeModal } from "@/store/modal.store";

interface ReportQuestionErrorModalProps {
	applicationId: string;
	examQuestionId: string | number;
	questionNumber: number;
}

export function ReportQuestionErrorModal({
	applicationId,
	examQuestionId,
	questionNumber,
}: ReportQuestionErrorModalProps) {
	const [content, setContent] = useState("");
	const { reportQuestionError, isReportingError } =
		useReportQuestionError(applicationId);

	const handleSubmit = async () => {
		if (!content.trim()) {
			toast.error("Descreva o problema encontrado na questão.");
			return;
		}

		try {
			await reportQuestionError({
				examQuestionId,
				content: content.trim(),
			});
			toast.success(
				"Obrigado! Analisaremos a sua solicitação e informaremos o resultado, caso necessário.",
			);
			closeModal();
		} catch {
			toast.error("Erro ao reportar problema na questão. Tente novamente.");
		}
	};

	return (
		<DialogContent className="max-w-md rounded-md p-8">
			<DialogHeader className="space-y-2">
				<DialogTitle className="text-xl font-bold text-slate-900">
					Reportar erro na questão {questionNumber}
				</DialogTitle>
				<DialogDescription className="text-slate-500">
					Relate abaixo qual o problema referente a esta questão.
				</DialogDescription>
			</DialogHeader>
			<Textarea
				rows={6}
				placeholder="Descreva o problema encontrado..."
				className="mt-4 border-slate-200 text-base text-slate-950 p-4 resize-y"
				value={content}
				onChange={(e) => setContent(e.target.value)}
			/>
			<DialogFooter className="flex flex-col-reverse sm:flex-row gap-3 mt-6">
				<Button
					variant="ghost"
					onClick={closeModal}
					disabled={isReportingError}
					className="flex-1 h-12 rounded-md font-bold"
				>
					Cancelar
				</Button>
				<Button
					variant="destructive"
					onClick={handleSubmit}
					disabled={isReportingError}
					className="flex-1 h-12 rounded-md font-bold"
				>
					{isReportingError ? (
						<>
							<Loader2 className="mr-2 h-4 w-4 animate-spin" />
							Enviando...
						</>
					) : (
						"Enviar"
					)}
				</Button>
			</DialogFooter>
		</DialogContent>
	);
}
